<template>
  <Nav />
  <a-row type="flex" justify="center">
    <a-col
      :xs="24"
      :sm="24"
      :md="24"
      :lg="12"
      :xl="12"
      :xxl="12"
      align="center"
    >
      <!-- 個人資訊 -->
      <a-card :style="{ width: '80%', 'margin-top': '-32px' }" :minHeight="144">
        <a-row>
          <a-col :span="8" align="center">
            <img v-if="AccountPictureUrl" :width="48" :src="`${AccountPictureUrl}`" :style="{'border-radius':'32px'}" :showZero="true"/>
            <div v-else :style="{'width': '48px', 'height': '48px', 'border-radius': '32px', 'background-color': '#f0f0f0', 'display': 'inline-block'}"></div>
            <p>{{ AccountName || '用戶' }}</p>
          </a-col>
          <a-col :span="8" align="left">
            <p>待付款</p>
            <p>預約成功</p>
          </a-col>
          <a-col :span="8" align="left">
            <p>
              <router-link to="/booking/my">
                <a-badge :count="unpaidCount" :showZero="true" />
              </router-link>
            </p>
            <p>
              <router-link to="/booking/my">
                <a-badge
                  :count="bookedCount"
                  :showZero="true"
                  :number-style="{
                    backgroundColor: '#fff',
                    color: '#999',
                    boxShadow: '0 0 0 1px #d9d9d9 inset',
                  }"
                />
              </router-link>
            </p>
          </a-col>
        </a-row>
      </a-card>
    </a-col>
  </a-row>
  <p><br /></p>
    <!-- 我要預約 -->
  <a-row type="flex" justify="center">
      <a-col
        :xs="24"
        :sm="24"
        :md="24"
        :lg="12"
        :xl="12"
        :xxl="12"
        align="center"
      >
        <a-card :style="{ width: '60%', 'margin-top': '-32px' }" :minHeight="144">
          <router-link to="/booking">
            <a-button type="primary"><BookOutlined />我要預約</a-button>
          </router-link>
        </a-card>
      </a-col>
  </a-row>
  <p><br /></p>
  <!-- Line傳訊 -->
  <Contact />
  <p><br /></p>
  <!-- 文字介紹 -->
  <a-row type="flex" class="introduction" justify="center">
    <a-col
      :xs="24"
      :sm="24"
      :md="24"
      :lg="12"
      :xl="12"
      :xxl="12"
      align="center"
    >
      <a-collapse :defaultActiveKey="activeKey">
        <a-collapse-panel key="1" header="價格方案費用" align="left">
          <ul :style="{'padding-left':'16px'}">
            <li> 平日早上 一小時300 （9:00-18:00前）</li>
            <li> 平日晚上 一小時350    (18:00-22:00)</li>
            <li> 星期六 一小時350  （9:00-18:00)</li>
            <br />
            <li> <strong><span :style="{'color':'#a00'}">單日單次預約連續 6 小時以上</span></strong>包場優惠每小時折50元。(當日需另付保證金1000，結束後退還保證金)</li>
            <br />
            <li> 若有飲食需求，人頭數*10元</li>
            <li> 週日及國定假日未開放，如有租借需求，將有額外加乘費用</li>
            <li> 可預約時段9:00-22:00</li>
            <li> 系統無法受理<strong><span :style="{'color':'#a00'}">三日以內</span></strong>之預約，如有租借需求請私訊 line官方帳號由專人處理</li>
          </ul>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="場地位置與環境簡介" :disabled="false" align="left">
          <p>場地設備：音響、投影機、布幕、會議桌椅、瑜珈墊、瑜珈磚、登階踏板 等訓練器材）</p>
          <p><a-image :src="require('../assets/desc-1.jpg')" /></p>
          <p><a-image :src="require('../assets/desc-2.jpg')" /></p>
          <p>地址：<strong>高雄市三民區山東街149號2樓</strong></p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.24602776554!2d120.3089321753682!3d22.64461387944062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e05c349868a0f%3A0xe7b1cae367acebdd!2z5b2O55qEIOW3peS9nOWupA!5e0!3m2!1szh-TW!2stw!4v1668390766490!5m2!1szh-TW!2stw" width="100%" height="350px" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </a-collapse-panel>
        <a-collapse-panel key="3" header="空間使用須知" align="left">
         <p :style="{'color':'#da0000'}">空間使用須知（租借前請務必詳閱此說明）</p>
          <ul :style="{'padding-left':'16px'}">
         <li> 場館內全面<strong><span :style="{'color':'#a00'}">禁菸</span></strong>。 </li>

          <li> 為維護其他團隊之權益，請於<strong><span :style="{'color':'#a00'}">預定時間抵達，並於撤場時間內準時離開。</span></strong><br />
          <span :style="{'color':'#666'}">（入場及撤場均給予10分鐘。請勿利用撤場時間繼續使用工作室進行活動，超時15分鐘將額外勺收半小時費用。）</span></li>

          <li> 運動及團體課程，<strong><span :style="{'color':'#a00'}">場館內禁止飲食。</span></strong></li>

         <li>  飲用水得至一樓裝盛。會議、展覽、包場等具餐會目的之活動，勺收清潔費<strong><span :style="{'color':'#a00'}">10元/人頭</span></strong>（以當日活動總人數收費）。</li>

          <li> 禁止於鏡面、牆面使用不易清除或易傷害表面之黏膠<span :style="{'color':'#666'}">（如雙面膠、快乾、大力膠等等）</span>。</li>

          <li> 使用場地請使用乾淨之<strong><span :style="{'color':'#a00'}">室內鞋</span></strong>。</li>

           <li>除包場活動外，場地不收保證金，<strong><span :style="{'color':'#a00'}">器材地板損壞需照價賠償</span></strong>。</li>

          <li> 場館器材，與授課內容相符者均可使用，非相關器材請勿任意取用。</li>

          <li>長期租用團體，若有器材放置需求，可繳納<strong><span :style="{'color':'#a00'}">月租/300元</span></strong>，以表面積50*40公分為限。
    工作室保有徵回空間權利，若有徵回需求，將按比例返還租金；工作室亦有權利依器材之增減調整會員物品至合適位置。</li>
          
          <li> 租借者<strong><span :style="{'color':'#a00'}">請勿翻找飲料店耗材原物料</span></strong>等等，如有違反情事，以100/人頭勺收費用。</li>
          <li> <strong><span :style="{'color':'#a00'}">包場活動保證金為新台幣1000元</span></strong>，於當日到場時繳交。離場前，由工作室負責人檢查教室及器材<span :style="{'color':'#666'}">（例如投影機、鏡面、音響等）</span>完整無虞，即退還。</li>
          </ul>
        </a-collapse-panel>
         <a-collapse-panel key="4" header="取消或更改預約" :disabled="false" align="left">
           <ul :style="{'padding-left':'16px'}">
          <li> 租借日的<strong><span :style="{'color':'#a00'}">五日前取消，退款半額</span></strong>（範例，租借日9/10，須在9/5 23:59前取消，得退款半額）</li>
          <li> 租借日的<strong><span :style="{'color':'#a00'}">五日內取消，不退款。</span></strong>（範例，租借日9/10，9/6 00:00開始即不予退款</li>
          <li> <strong><span :style="{'color':'#a00'}">繳費後欲更改時間勺收 150元</span></strong> 人工處理費，請私訊小編協調。</li>
          <li> 預約當日均不受理任何時間更動，亦不退款。</li>
          <li> 退款手續費15元。</li>
          <li> 如預約當日遇政府公告之天災人禍等情事，得更改或取消預約，不予額外收費。</li>
          </ul>
        </a-collapse-panel>
      </a-collapse>
    </a-col>
  </a-row>
</template>

<script>
// @ is an alias to /src
import Nav from "@/components/Nav.vue";
import { BookOutlined } from "@ant-design/icons-vue";
import {apiAccountLogin,apiAccountMe} from "@/utils/api/apiAuth.js";
import { isProxy, toRaw,createApp, computed, onMounted, watch } from 'vue';
import store from '@/store/'
import { useStore } from 'vuex'
import {apiBookingMyList} from "@/utils/api/apiBooking.js";
import Contact from "@/components/Share/Contact.vue";
import { useRoute } from 'vue-router';

export default {
  name: "HomeView",
  components: {
    Nav,
    BookOutlined,
    Contact,
  },
  setup: function (props) {
      const $store = useStore()
      const $route = useRoute();

      watch(() => $store.state.loginAccount, (val, old) => {
        console.log('triggerLoginAccount',val, old)
        this.getLoginStatus();
      })
      let iffState=null;

      try{
        iffState = $route.query['liff.state'].split('=');
      }catch(e){

      }
      
      let info = null;
      let nextRoute = null;

      try{
        if(iffState[0]=='?info'){
          info = iffState[1];
        }
      }catch(e){

      }

      try{
        if(iffState[0]=='?booking' && iffState[1]=='my'){
          console.log('dasdsa');
          nextRoute = '/booking/my';
        }
      }catch(e){

      }

      let activeKey = null;

      switch(info){
        case 'price':
          activeKey = '1';
        break;
        case 'intro':
          activeKey = '2';
        break;
        case 'notice':
          activeKey = '3';
        break;
        case 'cancel':
          activeKey = '4';
        break;
      }

      //捲軸至
      if(activeKey != null){
        setTimeout(function(){
          const el = document.getElementsByClassName('introduction')[0];
      
          if (el) {
            el.scrollIntoView();
          }
        },600);
        
      }

    return {
      activeKey,
      nextRoute,
    }
  },
  data:()=>{
    return{
      'AccountPictureUrl':null,
      'AccountName':null,
      'AccountDataReady':false,
      unpaidCount:0,//未付款數量
      bookedCount:0,//已預訂數量
    }
  },
  watch:{
  },
  computed:{

  },
  methods:{
    getLoginStatus:function(){
      let obj = this;
      setTimeout(() => { 
        
          //取得已登入的帳號資料
        let loginAccount = obj.$store.getters.getLoginAccount;

        if(typeof(loginAccount)=='object' && loginAccount !== null){
          this.AccountPictureUrl = loginAccount.pictureUrl;
          this.AccountName = loginAccount.name;

          this.AccountDataReady = true;
        } else {
          // 當沒有登入資料時，清空顯示
          this.AccountPictureUrl = '';
          this.AccountName = '';
          this.AccountDataReady = false;
        }

        if(obj.AccountDataReady==false)obj.getLoginStatus();
       
      }, 500);
    },
    getBookingInfo:function(){
      let params = {}
          apiBookingMyList(params).then(res=>{
    
              let reData = res.data.datas;

              //處理未付款資料
              let unpaid = reData.unpaid;
              this.unpaidCount = unpaid.info.billingCount;

              //處理已預訂的資料
              let booked = reData.booked;

              this.bookedCount = booked.list.length;
              console.log('count',this.bookedCount,this.unpaidCount);
          }).catch(error => {
              // 處理 API 錯誤
              const errorMessage = error.response?.data?.message;
              if (errorMessage === 'LineAccount 找不到用戶資料') {
                  // 顯示提示訊息
                  this.$message.warning('用戶資料不存在，請重新登入');
                  // 清除本地存儲的認證資料
                  this.$store.dispatch('clearAuth');
                  // 重置本地狀態
                  this.AccountPictureUrl = '';
                  this.AccountName = '';
                  this.AccountDataReady = false;
                  this.unpaidCount = 0;
                  this.bookedCount = 0;
                  // 延遲導向登入頁面，讓用戶看到提示訊息
                  setTimeout(() => {
                      this.$router.push('/login');
                  }, 1500);
              } else {
                  // 處理其他錯誤
                  console.error('API 錯誤:', error);
                  this.$message.error('載入預約資料失敗');
              }
          });
    },
    collapseChange:function(item){
      console.log('item',item);

      this.activeKey = item;
    }
  },
  mounted:function(){
    //抓取登入資料
    this.getLoginStatus();
    //抓取預定資料
    this.getBookingInfo();
    
    if(this.nextRoute != null){
      this.$router.push({'path':this.nextRoute});
    }
  }
};
</script>

<style lang="scss">
ul li{
  margin:8px 0;
}
</style>